// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"636":"029b75f0","761":"e6e444a4"}[chunkId] + ".js";
};